import script from "./ModalZoomImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalZoomImage.vue?vue&type=script&lang=ts&setup=true"

import "./ModalZoomImage.vue?vue&type=style&index=0&id=96ffb9ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96ffb9ca"]])

export default __exports__